exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".o-bb-popup {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-top: -5px; }\n  .o-bb-popup__action {\n    color: #707070;\n    cursor: pointer;\n    display: block;\n    font-size: 12px;\n    font-weight: 300;\n    padding: 12px;\n    position: relative;\n    text-decoration: none;\n    text-transform: uppercase; }\n    .o-bb-popup__action:hover {\n      background: #eee; }\n    .o-bb-popup__action--active {\n      color: #000; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/@browsbox-ui/bb-popup/popup.scss
// module id = 1913
// module chunks = 0